import BaseModel from "./BaseModel"
import Notification from "./Notification"
import moment from "moment";

export default class User extends BaseModel {

	static entity = 'users';
	static route = 'users';
	static plural = 'users';
	static singular = 'user';

	static fields () {
		return {
			id: this.attr(null),
			name: this.attr(null),
			email: this.attr(null),
			notification_preference: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			notifications: this.hasMany(Notification, 'notifiable_id', 'id'),
		}
	}

	static missingFields(entity) {
		//console.log(JSON.parse(JSON.stringify(entity)));
		let missing = [];
		let required = ['email', 'notification_preference'];
		if(!entity || !entity.id) {
			return missing;
		} else {
			required.forEach((field) => {
				if(!entity[field] || entity[field] === '') {
					missing.push(field);
				}
			});
		}
		return missing;
	}

	static isExpired(entity) {
		if(!entity || !entity.id) {
			return false;
		} else if(entity.updated_at) {
			return moment(entity.updated_at).diff(moment(), 'months') >= 6;
		} else if(entity.created_at) {
			return moment(entity.created_at).diff(moment(), 'months') >= 6;
		}
		return true;
	}

}
